import { render } from "./ProjectDossier.vue?vue&type=template&id=30fe0242&scoped=true"
import script from "./ProjectDossier.vue?vue&type=script&lang=js"
export * from "./ProjectDossier.vue?vue&type=script&lang=js"

import "./ProjectDossier.vue?vue&type=style&index=0&id=30fe0242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fe0242"]])

export default __exports__